export default {"src":"/_next/static/media/carFullCircle_24.3487a6e5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};